import { createSelector } from 'reselect';

import { AppState } from '../../store/store';
import { SingleInquiryState } from './single-inquiry-reducer';
import { accountDeliveryAddressesSelector } from './configuration-selectors';

const singleInquiryState = (state: AppState): SingleInquiryState => state.singleInquiry;

export const singleInquiryDataSelector = createSelector(
    [singleInquiryState, accountDeliveryAddressesSelector],
    (singleInquiryModal, deliveryAddresses) => ({
        isOpen: singleInquiryModal.isSingleInquiryModalOpen,
        initialValues: {
            ...singleInquiryModal.initialValues,
            deliveryDate: singleInquiryModal.initialValues.deliveryDate ?? null,
            items:
                singleInquiryModal.initialValues.items && singleInquiryModal.initialValues.items.length > 0
                    ? singleInquiryModal.initialValues.items
                    : [{ id: 1, articleName: '', quantity: null }],
            deliveryAddressId: deliveryAddresses[0]?.id ?? 0,
            files: singleInquiryModal.initialValues.files ?? [],
        },
    })
);
